import React from 'react';
import PvConsumptionQuestions from './PvConsumptionQuestions';

const PvFormStep = ({ 
    pvData, 
    pvProgression, 
    onPvDataChange, 
    onPvOwnershipChange, 
    onCancel, 
    onNext, 
    isPvStepValid,
    isPvQualified,
    isPvDisqualified 
}) => {
    return (
        <div className="pv-form-step">
            <h2 className="form-title">☀️ PV Anlage</h2>

            {/* Eigentümer - Immer sichtbar als erstes Element */}
            <div className="form-section">
                <label className="form-label required">Eigentümer</label>
                <div className="yes-no-buttons">
                    <button
                        type="button"
                        className={`yes-button ${pvData.isOwner === true ? 'selected' : ''}`}
                        onClick={() => onPvOwnershipChange(true)}
                    >
                        <div className="icon-container">
                            <svg viewBox="0 0 24 24" className="yes-icon">
                                <path
                                    d="M4 12.6L9 17.6L20 6.6"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                        <span>Ja</span>
                    </button>
                    <button
                        type="button"
                        className={`no-button ${pvData.isOwner === false ? 'selected' : ''}`}
                        onClick={() => onPvOwnershipChange(false)}
                    >
                        <div className="icon-container">
                            <svg viewBox="0 0 24 24" className="no-icon">
                                <path
                                    d="M5 5L19 19M5 19L19 5"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                        <span>Nein</span>
                    </button>
                </div>

                {/* Qualifizierungsnachricht für Eigentümer */}
                {pvData.isOwner === false && (
                    <div className="qualification-message disqualified">
                        <svg viewBox="0 0 24 24" className="qualification-icon">
                            <path
                                d="M5 5L19 19M5 19L19 5"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <span>Lead nicht Qualifiziert</span>
                    </div>
                )}
            </div>

            {/* Gebäudeart - Zeige nur, wenn Eigentümer ausgewählt ist */}
            {pvProgression >= 2 && (
                <div className="form-section">
                    <label className="form-label required">Gebäudeart</label>
                    <div className="building-type-buttons">
                        <button
                            type="button"
                            className={`building-button ${pvData.buildingType === 'Einfamilienhaus' ? 'selected' : ''}`}
                            onClick={() => onPvDataChange({ buildingType: 'Einfamilienhaus' })}
                        >
                            <div className="building-icon">
                                <svg viewBox="0 0 100 100">
                                    <path d="M50,20 L20,45 L20,80 L80,80 L80,45 Z" fill="none" stroke="currentColor" strokeWidth="3" />
                                    <rect x="35" y="50" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" />
                                    <rect x="55" y="50" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" />
                                    <rect x="45" y="65" width="10" height="15" fill="none" stroke="currentColor" strokeWidth="2" />
                                </svg>
                            </div>
                            <span>Einfamilienhaus</span>
                        </button>
                        <button
                            type="button"
                            className={`building-button ${pvData.buildingType === 'Zweifamilienhaus' ? 'selected' : ''}`}
                            onClick={() => onPvDataChange({ buildingType: 'Zweifamilienhaus' })}
                        >
                            <div className="building-icon">
                                <svg viewBox="0 0 100 100">
                                    <path d="M50,20 L15,45 L15,80 L85,80 L85,45 Z" fill="none" stroke="currentColor" strokeWidth="3" />
                                    <line x1="50" y1="45" x2="50" y2="80" stroke="currentColor" strokeWidth="2" />
                                    <rect x="25" y="50" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" />
                                    <rect x="65" y="50" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" />
                                    <rect x="30" y="65" width="10" height="15" fill="none" stroke="currentColor" strokeWidth="2" />
                                    <rect x="60" y="65" width="10" height="15" fill="none" stroke="currentColor" strokeWidth="2" />
                                </svg>
                            </div>
                            <span>Zweifamilienhaus</span>
                        </button>
                        <button
                            type="button"
                            className={`building-button ${pvData.buildingType === 'Reihenhaus' ? 'selected' : ''}`}
                            onClick={() => onPvDataChange({ buildingType: 'Reihenhaus' })}
                        >
                            <div className="building-icon">
                                <svg viewBox="0 0 100 100">
                                    <path d="M10,80 L10,45 L30,30 L30,80 Z M30,80 L30,30 L50,30 L50,80 Z M50,80 L50,30 L70,30 L70,80 Z M70,80 L70,30 L90,45 L90,80 Z" fill="none" stroke="currentColor" strokeWidth="2" />
                                    <rect x="15" y="60" width="8" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" />
                                    <rect x="37" y="60" width="8" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" />
                                    <rect x="56" y="60" width="8" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" />
                                    <rect x="77" y="60" width="8" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" />
                                </svg>
                            </div>
                            <span>Reihenhaus</span>
                        </button>
                    </div>
                </div>
            )}

            {/* Dachausrichtung */}
            {pvProgression >= 3 && (
                <div className="form-section">
                    <label className="form-label required">Dachausrichtung</label>
                    <div className="roof-orientation-buttons">
                        <button
                            type="button"
                            className={`direction-button ${pvData.roofOrientation === 'West' ? 'selected' : ''}`}
                            onClick={() => onPvDataChange({ roofOrientation: 'West' })}
                        >
                            <div className="direction-icon">
                                <svg viewBox="0 0 24 24">
                                    <path d="M4 12h12M4 12l5 -5M4 12l5 5" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <span>West</span>
                        </button>
                        <button
                            type="button"
                            className={`direction-button ${pvData.roofOrientation === 'Ost' ? 'selected' : ''}`}
                            onClick={() => onPvDataChange({ roofOrientation: 'Ost' })}
                        >
                            <div className="direction-icon">
                                <svg viewBox="0 0 24 24">
                                    <path d="M20 12H8M20 12l-5 -5M20 12l-5 5" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <span>Ost</span>
                        </button>
                        <button
                            type="button"
                            className={`direction-button ${pvData.roofOrientation === 'Nord' ? 'selected' : ''}`}
                            onClick={() => onPvDataChange({ roofOrientation: 'Nord' })}
                        >
                            <div className="direction-icon">
                                <svg viewBox="0 0 24 24">
                                    <path d="M12 4v12M12 4l-5 5M12 4l5 5" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <span>Nord</span>
                        </button>
                        <button
                            type="button"
                            className={`direction-button ${pvData.roofOrientation === 'Süd' ? 'selected' : ''}`}
                            onClick={() => onPvDataChange({ roofOrientation: 'Süd' })}
                        >
                            <div className="direction-icon">
                                <svg viewBox="0 0 24 24">
                                    <path d="M12 20V8M12 20l-5 -5M12 20l5 -5" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <span>Süd</span>
                        </button>
                    </div>

                    {/* Qualifizierungsnachricht für Dachausrichtung */}
                    {pvData.roofOrientation === 'Nord' && (
                        <div className="qualification-message disqualified">
                            <svg viewBox="0 0 24 24" className="qualification-icon">
                                <path
                                    d="M5 5L19 19M5 19L19 5"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span>Lead nicht Qualifiziert</span>
                        </div>
                    )}
                </div>
            )}

            {/* Dachfläche über 20QM */}
            {pvProgression >= 4 && (
                <div className="form-section">
                    <label className="form-label required">Dachfläche über 20QM</label>
                    <div className="yes-no-buttons">
                        <button
                            type="button"
                            className={`yes-button ${pvData.roofAreaOver20 === true ? 'selected' : ''}`}
                            onClick={() => onPvDataChange({ roofAreaOver20: true })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="yes-icon">
                                    <path
                                        d="M4 12.6L9 17.6L20 6.6"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                            <span>Ja</span>
                        </button>
                        <button
                            type="button"
                            className={`no-button ${pvData.roofAreaOver20 === false ? 'selected' : ''}`}
                            onClick={() => onPvDataChange({ roofAreaOver20: false })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="no-icon">
                                    <path
                                        d="M5 5L19 19M5 19L19 5"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                            <span>Nein</span>
                        </button>
                    </div>
                </div>
            )}

            {/* Dachflächengröße - nur wenn über 20qm = JA */}
            {pvProgression >= 5 && pvData.roofAreaOver20 === true && (
                <div className="form-section">
                    <label className="form-label required">Wie viele QM?</label>
                    <input
                        type="number"
                        name="roofAreaSize"
                        value={pvData.roofAreaSize}
                        onChange={(e) => onPvDataChange({ roofAreaSize: e.target.value })}
                        className="form-input"
                        placeholder="z.B. 40"
                        required
                    />

                    {/* Qualifizierungsnachricht für Dachflächengröße */}
                    {Number(pvData.roofAreaSize) < 20 && pvData.roofAreaSize !== '' && (
                        <div className="qualification-message disqualified">
                            <svg viewBox="0 0 24 24" className="qualification-icon">
                                <path
                                    d="M5 5L19 19M5 19L19 5"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span>Lead nicht Qualifiziert</span>
                        </div>
                    )}
                </div>
            )}

            {/* Alternative Montage - nur wenn über 20qm = NEIN */}
            {pvProgression >= 6 && pvData.roofAreaOver20 === false && (
                <div className="form-section">
                    <label className="form-label required">Alternative Montage möglich (Carport, Garage)?</label>
                    <div className="yes-no-buttons">
                        <button
                            type="button"
                            className={`yes-button ${pvData.hasAlternativeMounting === true ? 'selected' : ''}`}
                            onClick={() => onPvDataChange({ hasAlternativeMounting: true })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="yes-icon">
                                    <path
                                        d="M4 12.6L9 17.6L20 6.6"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                            <span>Ja</span>
                        </button>
                        <button
                            type="button"
                            className={`no-button ${pvData.hasAlternativeMounting === false ? 'selected' : ''}`}
                            onClick={() => onPvDataChange({ hasAlternativeMounting: false })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="no-icon">
                                    <path
                                        d="M5 5L19 19M5 19L19 5"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                            <span>Nein</span>
                        </button>
                    </div>

                    {/* Qualifizierungsnachricht wenn keine alternative Montage */}
                    {pvData.hasAlternativeMounting === false && (
                        <div className="qualification-message disqualified">
                            <svg viewBox="0 0 24 24" className="qualification-icon">
                                <path
                                    d="M5 5L19 19M5 19L19 5"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span>Lead nicht Qualifiziert</span>
                        </div>
                    )}
                </div>
            )}

            {/* Alternative Montagefläche - nur wenn alternative Montage = JA */}
            {pvProgression >= 7 && pvData.roofAreaOver20 === false && pvData.hasAlternativeMounting === true && (
                <div className="form-section">
                    <label className="form-label required">Wie viele QM alternative Montagefläche?</label>
                    <input
                        type="number"
                        name="alternativeMountingArea"
                        value={pvData.alternativeMountingArea}
                        onChange={(e) => onPvDataChange({ alternativeMountingArea: e.target.value })}
                        className="form-input"
                        placeholder="z.B. 25"
                        required
                    />

                    {/* Qualifizierungsnachricht für alternative Montagefläche */}
                    {Number(pvData.alternativeMountingArea) < 20 && pvData.alternativeMountingArea !== '' && (
                        <div className="qualification-message disqualified">
                            <svg viewBox="0 0 24 24" className="qualification-icon">
                                <path
                                    d="M5 5L19 19M5 19L19 5"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span>Lead nicht Qualifiziert</span>
                        </div>
                    )}
                </div>
            )}

            {/* Denkmalschutz */}
            {pvProgression >= 8 && (
                <div className="form-section">
                    <label className="form-label required">Denkmalschutz / Asbest</label>
                    <div className="yes-no-buttons">
                        <button
                            type="button"
                            className={`yes-button reverse-yes-button ${pvData.hasMonumentProtection === true ? 'selected' : ''}`}
                            onClick={() => onPvDataChange({ hasMonumentProtection: true })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="yes-icon">
                                    <path
                                        d="M4 12.6L9 17.6L20 6.6"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                            <span>Ja</span>
                        </button>
                        <button
                            type="button"
                            className={`reverse-no-button ${pvData.hasMonumentProtection === false ? 'selected' : ''}`}
                            onClick={() => onPvDataChange({ hasMonumentProtection: false })}
                        >
                            <div className="icon-container">
                                <svg viewBox="0 0 24 24" className="no-icon">
                                    <path
                                        d="M5 5L19 19M5 19L19 5"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                            <span>Nein</span>
                        </button>
                    </div>

                    {/* Qualifizierungsnachricht für Denkmalschutz */}
                    {pvData.hasMonumentProtection === true && (
                        <div className="qualification-message disqualified">
                            <svg viewBox="0 0 24 24" className="qualification-icon">
                                <path
                                    d="M5 5L19 19M5 19L19 5"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span>Lead nicht Qualifiziert</span>
                        </div>
                    )}
                </div>
            )}

            <PvConsumptionQuestions
                data={pvData}
                progression={pvProgression}
                onOver2700Change={(value) => onPvDataChange({
                    consumptionOver2700: value,
                    consumptionInRangeWith3Months: value ? null : pvData.consumptionInRangeWith3Months,
                    hasRealizationTimeframe: value ? pvData.hasRealizationTimeframe : null,
                    yearlyConsumption: value ? pvData.yearlyConsumption : ''
                })}
                onYearlyConsumptionChange={(value) => onPvDataChange({ yearlyConsumption: value })}
                onRangeWith3MonthsChange={(value) => onPvDataChange({ consumptionInRangeWith3Months: value })}
                onRealizationTimeframeChange={(value) => onPvDataChange({ hasRealizationTimeframe: value })}
                showQualifiedBanner
                isQualified={isPvQualified()}
                isDisqualified={isPvDisqualified()}
                isStepValid={isPvStepValid()}
            />
            <div className="form-actions">
                <button type="button" className="cancel-button" onClick={onCancel}>
                    Abbrechen
                </button>
                <button
                    type="button"
                    className="next-button"
                    onClick={onNext}
                    disabled={!isPvStepValid()}
                >
                    Weiter zu WP →
                </button>
            </div>
        </div>
    );
};

export default PvFormStep;

